import { useState, useEffect } from 'react';
import { YSFormCard } from './YS.styles';

const hourOptions = () => {
    let result = [<option key={-1} value="">시</option>];
    for (let i = 0; i < 24; i++) {
        let v = String(i).padStart(2, '0');
        result.push(<option key={i} value={v}>{i}시</option>);
    }
    return result;
};

const minuteOptions = () => {
    let result = [<option key={-1} value="">분</option>];
    for (let i = 0; i < 12; i++) {
        let v = String(i * 5).padStart(2, '0');
        result.push(<option key={i} value={v}>{i * 5}분</option>);
    }
    return result;
};

const YSForm = ({ name, onSave, onShowList, onOpenMap, departure, destination, savedForm }) => {
    const [hour, setHour] = useState('');
    const [minute, setMinute] = useState('');
    const [hasCar, setHasCar] = useState(false);
    const [seats, setSeats] = useState(3);

    useEffect(() => {
        if (savedForm) {
            const [h, m] = savedForm.departureTime.split(':');
            setHour(h);
            setMinute(m);
            setHasCar(savedForm.hasCar);
            setSeats(savedForm.seats || 3);
        }
    }, [savedForm]);

    const handleSave = () => {
        if (!departure) {
            alert('출발지를 선택해주세요.');
            return;
        }
        if (!hour || !minute) {
            alert('출발 시간을 선택해주세요.');
            return;
        }
        if (!destination) {
            alert('도착지를 선택해주세요.');
            return;
        }

        onSave({
            name,
            departure,
            departureTime: hour + ':' + minute,
            hasCar,
            seats: hasCar ? parseInt(seats) : 0,
            destination,
            updatedAt: new Date().toISOString()
        });
    };

    return (
        <YSFormCard>
            <div className='formGroup'>
                <label>{name}님, 정보를 입력하세요</label>
            </div>

            <div className='formGroup'>
                <label>출발지</label>
                <input
                    type="text"
                    placeholder="지도에서 선택하세요"
                    onClick={() => onOpenMap("departure")}
                    value={departure ? departure.label : ""}
                    readOnly
                />
            </div>

            <div className='formGroup'>
                <label>출발 시간</label>
                <div className='timeRow'>
                    <select value={hour} onChange={(e) => setHour(e.target.value)}>
                        {hourOptions()}
                    </select>
                    <select value={minute} onChange={(e) => setMinute(e.target.value)}>
                        {minuteOptions()}
                    </select>
                </div>
            </div>

            <div className='carRow'>
                <label>차량 운행</label>
                <div
                    className={'toggle ' + (hasCar ? 'on' : '')}
                    onClick={() => setHasCar(!hasCar)}
                />
                {hasCar && <>
                    <input
                        type="number"
                        className='seatsInput'
                        min="1"
                        max="10"
                        value={seats}
                        onChange={(e) => setSeats(e.target.value)}
                    />
                    <span className='seatsLb'>명 탑승 가능</span>
                </>}
            </div>

            <div className='formGroup'>
                <label>귀환 도착지 (집)</label>
                <input
                    type="text"
                    placeholder="지도에서 선택하세요"
                    onClick={() => onOpenMap("destination")}
                    value={destination ? destination.label : ""}
                    readOnly
                />
            </div>

            <div className='btnRow'>
                <button className='saveBtn' onClick={handleSave}>저장</button>
                <button className='listBtn' onClick={onShowList}>전체 현황</button>
            </div>
        </YSFormCard>
    );
};

export default YSForm;
